import React, { useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";

const dayOptions = Array.from({ length: 15 }, (_, i) => ({
  label: `${i + 1} Day${i > 0 ? "s" : ""}`,
  value: i + 1,
}));

const statusOptions = ["Pending", "Accepted", "Cancelled", "Processing", "Draft"];

const OrderDaysModal = ({
  show,
  onClose,
  onConfirm,
  completeDays,
  setCompleteDays,
  singleQuote,
  status,
  setStatus,
}) => {
  useEffect(() => {
    if (show && singleQuote?.due_date === "-") {
      setCompleteDays(5);
    }
  }, [show]);

  const getDueDate = (days) => {
    if (!days) return null;
    const dueDate = new Date();
    dueDate.setDate(dueDate.getDate() + parseInt(days));
    return dueDate.toLocaleDateString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
      <Modal.Title className="fs-6 d-flex justify-content-between align-items-center">
        <span>Set Order Details</span>
        <span className="badge bg-primary ms-1">Order #{singleQuote?.quote_no}</span>
      </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
        {status == "Accepted" && (
          <>
          <Form.Group className="mb-3">
            <Form.Label>Completion Time</Form.Label>
            <Form.Select
              value={completeDays}
              onChange={(e) => setCompleteDays(e.target.value)}
              size="sm"
            >
              <option value="">Select Days</option>
              {dayOptions.map((day) => (
                <option key={day.value} value={day.value}>
                  {day.label}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          {completeDays && (
            <div className="text-success fw-semibold small mb-3">
              Estimated Due Date: {getDueDate(completeDays)}
            </div>
          )}
         </>
        )}   
          <Form.Group className="mb-2">
            <Form.Label>Status</Form.Label>
            <Row>
            {statusOptions.map((opt, index) => {
              const id = `quoteStatus-${index}`;
              return (
                <Col xs={6} sm={4} key={opt} className="mb-1">
                  <Form.Check
                    type="radio"
                    name="quoteStatus"
                    id={id}
                    label={opt}
                    value={opt}
                    checked={status === opt}
                    onChange={(e) => setStatus(e.target.value)}        
                    style={{ cursor: 'pointer' }}
                  />
                </Col>
              );
            })}
            </Row>
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="outline-secondary" size="sm" onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="primary"
          size="sm"
          disabled={!completeDays || !status}
          onClick={() => {
            onConfirm(completeDays, status);
            onClose();
          }}
        >
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default OrderDaysModal;
